import React from "react";
import "./EventList.scss";

const LUMA_CALENDAR_ID = "cal-FQqjeAyHuljNXnI";

function EventList() {
  return (
    <div className="EventList">
      <iframe
        src={`https://lu.ma/embed/calendar/${LUMA_CALENDAR_ID}/events`}
        title="Interact Fellows Events"
        width="100%"
        height="600"
        frameBorder="0"
        allowFullScreen
        aria-hidden="false"
        tabIndex="0"
        style={{ border: "none", borderRadius: "8px" }}
      />
    </div>
  );
}

export default EventList;
